"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFactoryBinding = cloneFactoryBinding;
const cloneBindingCache_1 = require("./cloneBindingCache");
/**
 * Clones a FactoryBinding
 */
function cloneFactoryBinding(binding) {
    return {
        cache: (0, cloneBindingCache_1.cloneBindingCache)(binding.cache),
        factory: binding.factory,
        id: binding.id,
        isSatisfiedBy: binding.isSatisfiedBy,
        moduleId: binding.moduleId,
        onActivation: binding.onActivation,
        onDeactivation: binding.onDeactivation,
        scope: binding.scope,
        serviceIdentifier: binding.serviceIdentifier,
        type: binding.type,
    };
}
//# sourceMappingURL=cloneFactoryBinding.js.map